import styled from 'styled-components';
import TinyDateField from './component';

export default styled(TinyDateField)`
  .tiny-date-field__arrow {
    cursor: pointer;
    z-index: 10;

    &.up {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 3px 5px 3px;
      border-color: transparent transparent var(--grey700) transparent;
      position: absolute;
      top: 16px;
      right: 3px;
    }
    &.down {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 5px 3px 0 3px;
      border-color: var(--grey700) transparent transparent transparent;
      position: absolute;
      bottom: 16px;
      right: 3px;
    }
  }
  input {
    caret-color: transparent;
  }
`;
